import { computed, readonly, ref } from 'vue'
import equal from 'fast-deep-equal'

/**
 * Creates a pair of {@link ref}s to hold current and requested values, a {@link computed} `changing` and a `reset` fn.
 * @param initialValue
 * @returns Array to be destructured [current, requested, changing, reset]
 */
export const useChangeRequester = initialValue => {
  const currentRW = ref(initialValue)
  const current = readonly(currentRW)
  const requested = ref(initialValue)
  const changing = computed(() => !equal(current.value, requested.value))
  const reset = (value = initialValue) => {
    // console.log('use-change-requester.js reset', current.value, requested.value, '->', value)
    currentRW.value = value
    requested.value = value
  }
  return [current, requested, changing, reset]
}
